module.exports = __webpack_public_path__ + "img/placeholder.ce31b4ee.jpg";